import { supabase } from '@/integrations/supabase/client';
import { formatNameBR } from '@/utils/personName';

export type QuoteSendFormat = 'carousel' | 'text';

export function buildQuoteTextMessage(clientName: string | null, proposalUrl: string): string {
  const name = formatNameBR(clientName) || 'Cliente';
  return [
    `Olá, ${name}! É um prazer dar continuidade ao planejamento do seu evento.`,
    'Preparei as propostas de cardápio com base na variedade e qualidade que conversamos.',
    `📲 Confira as opções no link abaixo: ${proposalUrl}`,
  ].join('\n\n');
}

/**
 * Sends one text message through the supplier's WhatsApp. The connection is resolved
 * server-side (same rule as the carousel); never attempts a carousel in text mode.
 */
export async function sendQuoteText(supplierId: string, phone: string, message: string): Promise<boolean> {
  if (!supplierId || !phone || !message) return false;
  try {
    const { data, error } = await supabase.functions.invoke('send-quote-text', {
      body: { supplierId, phone, message },
    });
    return !error && data?.success === true;
  } catch {
    return false;
  }
}